import * as React from "react";
import { Form, Row, Col, Tag, Button, Icon, Tooltip } from "antd";
import { DeleteCreditCard, CreditCardConfirmation } from "../..";
import { ICreditCardRegistrationDto } from "Core/Api/Payment/Api";
import { CardInforFormStyle } from "./CardInfo.Style";
import ButtonGroup from "antd/lib/button/button-group";
import { FaCcVisa, FaCcMastercard, FaCreditCard } from "react-icons/fa";

export interface Props {
    children?: React.ReactNode
    cardDetails: ICreditCardRegistrationDto
    editButton(regId: number): any;
    reloadCardList(): any;
}

export interface State {
    confirmedClicked: boolean,
}

export default class CardInfo extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.collectRegIdEdit = this.collectRegIdEdit.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
        this.onConfirmCancel = this.onConfirmCancel.bind(this);

        this.state = {
            confirmedClicked: false,
        }
    }

    collectRegIdEdit(regId: number) {
        this.props.editButton(regId);
    }

    //check if confirm button is clicked; displayed based on state value 
    onConfirm(registrationId: number) {
        if (this.props.cardDetails !== undefined) {
            if (this.props.cardDetails.id === registrationId) {
                this.setState({ confirmedClicked: true })
            }
        }
    }

    onConfirmCancel() {
        this.setState({ confirmedClicked: false })
    }

    renderCardImage(cardFirstDigits?: string) {
        if (cardFirstDigits?.startsWith("4")) {
            return <FaCcVisa className="cardLogo" />;
        }

        if (cardFirstDigits?.startsWith("5")) {
            return <FaCcMastercard className="cardLogo" />
        } else {
            return <FaCreditCard className="cardLogo" />
        }
    }

    confirmCardMessage = (
        <p>
            A payment has been charged against your card. It is between $1 and $5.
            Please contact your bank to retrieve the value of this charge as it is needed to complete the card confirmation process.
            Click on the "Confirm" button to confirm card after retrieving amount from your bank.
        </p>
    );


    render() {
        const { cardDetails, reloadCardList } = this.props;
        return (
            <>
                {/* <Form key={this.props.cardDetails.id} style={{ textAlign: 'left', border: '1px lightgrey solid', marginBottom: '10px', padding: '10px' }}> */}
                <CardInforFormStyle key={this.props.cardDetails.id} >
                    <Row className='cardInfo' style={{ borderTop: cardDetails.isConfirmed ? "solid lime 2px" : "solid red 2px", }}>
                        <Col>
                            <Row justify="space-around" className="cardAlignment">
                                <Col xs={{ span: 24, }}
                                    sm={{ span: 24, }}
                                    md={{ span: 24, }}
                                    lg={{ span: 9, }}
                                    xl={{ span: 9, }}>
                                    {this.renderCardImage(cardDetails.cardNumberFirstFourDigits)}
                                </Col>
                                <Col xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 9, }}
                                    xl={{ span: 9, }}>
                                    <article>
                                        <section className="cardDetails">
                                            <p style={{ fontWeight: 'bold', fontSize: "16", margin: 0 }}>{cardDetails.cardNumberFirstFourDigits} **** **** {this.props.cardDetails.cardNumberLastFourDigits}</p>
                                            <p style={{ margin: 0 }}>{cardDetails.cardName}</p>
                                            <p style={{ margin: 0, paddingBottom: 5 }}>Status: {cardDetails.isConfirmed ?
                                                <Tag color="green">Confirmed</Tag> :
                                                <Tooltip title={this.confirmCardMessage}>
                                                    <Tag color="red">Unconfirmed</Tag><Icon style={{ color: "red" }} type="info-circle" />
                                                </Tooltip>
                                            }</p>
                                        </section>
                                    </article>
                                </Col>

                                <Col xs={{ span: 24 }}
                                    sm={{ span: 24 }}
                                    md={{ span: 24 }}
                                    lg={{ span: 5, }}
                                    xl={{ span: 5, }}>
                                    {/* <Row type="flex" justify="end">
                                        <DeleteCreditCard
                                            cardDetails={cardDetails}
                                            regId={cardDetails.id!}
                                            deleted={reloadCardList} />
                                        <Button size="small" style={{ backgroundColor: '#77DD2E', color: 'white', marginRight: 1, marginLeft: 1 }} icon="edit" onClick={() => this.collectRegIdEdit(cardDetails.id!)}>Edit</Button>
                                        {cardDetails.isConfirmed ? <></> :
                                            <Button size="small" type="primary" style={{ color: 'white', marginRight: 1, marginLeft: 1 }} onClick={() => this.onConfirm(cardDetails.id!)} >Confirm</Button>
                                        }
                                    </Row> */}

                                    <Row style={{ verticalAlign: "center" }}>
                                        <Col>
                                            {cardDetails.isConfirmed ? <></> :
                                                <Button size="large" type="primary" style={{ color: 'white', marginRight: 1, marginLeft: 1, width: 120 }} onClick={() => this.onConfirm(cardDetails.id!)} >Confirm</Button>
                                            }
                                        </Col>
                                        <Col>
                                            <Button size="large" style={{ backgroundColor: '#77DD2E', color: 'white', marginRight: 1, marginLeft: 1, marginTop: 5, width: 120 }} icon="edit" onClick={() => this.collectRegIdEdit(cardDetails.id!)}>Edit</Button>

                                        </Col>
                                        <Col>
                                            <DeleteCreditCard
                                                cardDetails={cardDetails}
                                                regId={cardDetails.id!}
                                                deleted={reloadCardList} />
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>

                            {this.state.confirmedClicked ?
                                <Row>
                                    <Col offset={1}>
                                        <CreditCardConfirmation
                                            cardDetails={cardDetails}
                                            regId={cardDetails.id!}
                                            cancelButton={this.onConfirmCancel}
                                            confirmed={reloadCardList} />
                                    </Col>
                                </Row>
                                : null}
                        </Col>
                    </Row>
                </CardInforFormStyle>
            </>
        )
    }
}
